<!-- TODO: This component can become generic with {sections} passed in as input in the .ts and an NgFor here -->
<div *ngIf="report" class="scrollspy-wrapper">
    <div [ngClass]="{'active':activeSection==='report-analysis'}" class="section-link"
        (click)="scrollTo('report-analysis')"><span i18n="report-scrollspy|@@damage_analysis">Analyse
            dommages</span><span class="damage-count-badge"
            *ngIf="numberDamage && numberDamage > 0">{{numberDamage}}</span>
    </div>
    <div *ngIf="showPreselection" [ngClass]="{'active':activeSection==='report-preselection'}" class="section-link"
        (click)="scrollTo('report-preselection')" i18n="report-scrollspy|@@preselected_pictures">Photos
        présélectionnées.
    </div>
    <div *ngIf="showSignatory" [ngClass]="{'active':activeSection==='report-signatory'}" class="section-link"
        (click)="scrollTo('report-signatory')"><span i18n="report-scrollspy|@@signatory">Signataire</span>
    </div>
    <div [ngClass]="{'active':activeSection==='report-vehicle'}" class="section-link"
        (click)="scrollTo('report-vehicle')"><span i18n="report-scrollspy|@@vehicle">Véhicule</span>
    </div>
    <div [ngClass]="{'active':activeSection==='report-checklist'}" class="section-link"
        (click)="scrollTo('report-checklist')"><span i18n="report-scrollspy|@@checklist">Checklist</span>
    </div>

     <div [ngClass]="{'active':activeSection==='annex_picture'}" class="section-link"
        (click)="scrollTo('annex_picture')"><span i18n="report-scrollspy|@@annex_picture">Photos annexe</span>
    </div>
    <!-- <div *ngIf="showVehicleDetails" [ngClass]="{'active':activeSection==='report-description'}" class="section-link"
        (click)="scrollTo('report-description')"><span i18n="report-scrollspy|@@vehicle_desccription">Description
            véhicule</span>
    </div> -->


    <!-- <div [ngClass]="{'active':activeSection==='report-interior'}" class="section-link"
        (click)="scrollTo('report-interior')"><span i18n="report-scrollspy|@@interior">Intérieur</span>
    </div> -->
    <div [ngClass]="{'active':activeSection==='report-tires'}" class="section-link" (click)="scrollTo('report-tires')">
        <span i18n="report-scrollspy|@@tires"> Pneus </span><span>
            <svg width="14px" height="16px" viewBox="0 0 14 16" version="1.1" xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink">
                <!-- Generator: Sketch 52.2 (67145) - http://www.bohemiancoding.com/sketch -->
                <title>Lock</title>
                <desc>Created with Sketch.</desc>
                <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                    <g id="UI-Rapport" transform="translate(-511.000000, -2904.000000)" fill-rule="nonzero">
                        <g id="Content" transform="translate(165.000000, 269.000000)">
                            <g id="07" transform="translate(285.000000, 2632.000000)">
                                <g id="Title" transform="translate(1.000000, 0.000000)">
                                    <path
                                        d="M67,3 C64.8,3 63,4.8 63,7 L63,8 L61,8 C60.4,8 60,8.4 60,9 L60,18 C60,18.6 60.4,19 61,19 L73,19 C73.6,19 74,18.6 74,18 L74,9 C74,8.4 73.6,8 73,8 L71,8 L71,7 C71,4.8 69.2,3 67,3 Z M68,14.7 L68,16 L66,16 L66,14.7 C65.4,14.4 65,13.7 65,13 C65,11.9 65.9,11 67,11 C68.1,11 69,11.9 69,13 C69,13.7 68.6,14.4 68,14.7 Z M69,8 L65,8 L65,7 C65,5.9 65.9,5 67,5 C68.1,5 69,5.9 69,7 L69,8 Z"
                                        id="Shape"></path>
                                </g>
                            </g>
                        </g>
                    </g>
                </g>
            </svg>
        </span>
    </div>


    <!--TODO: uncomment this when Costs section is implemented-->
    <!--<div [ngClass]="{'active':activeSection==='report-costs'}" class="section-link" (click)="scrollTo('report-costs')">Chiffrage
    </div>-->
    <div [ngClass]="{'active':activeSection==='report-details'}" class="section-link"
        (click)="scrollTo('report-details')"><span i18n="report-scrollspy|@@report_data">Informations rapport</span>
    </div>
</div>
<div *ngIf="!report" class="scrollspy-wrapper">
    <content-loader [width]="300" [height]="50">
        <svg:rect id="rect3686" width="100%" height="40" x="0" y="0" rx="3" ry="3"
            style="fill:#f9f9f9;fill-opacity:0.97894736;stroke:none;stroke-width:0.26458332;stroke-opacity:1" />
    </content-loader>
    <content-loader [width]="300" [height]="50">
        <svg:rect id="rect3686" width="100%" height="40" x="0" y="0" rx="3" ry="3"
            style="fill:#f9f9f9;fill-opacity:0.97894736;stroke:none;stroke-width:0.26458332;stroke-opacity:1" />
    </content-loader>
    <content-loader [width]="300" [height]="50">
        <svg:rect id="rect3686" width="100%" height="40" x="0" y="0" rx="3" ry="3"
            style="fill:#f9f9f9;fill-opacity:0.97894736;stroke:none;stroke-width:0.26458332;stroke-opacity:1" />
    </content-loader>
    <content-loader [width]="300" [height]="50">
        <svg:rect id="rect3686" width="100%" height="40" x="0" y="0" rx="3" ry="3"
            style="fill:#f9f9f9;fill-opacity:0.97894736;stroke:none;stroke-width:0.26458332;stroke-opacity:1" />
    </content-loader>
    <content-loader [width]="300" [height]="50">
        <svg:rect id="rect3686" width="100%" height="40" x="0" y="0" rx="3" ry="3"
            style="fill:#f9f9f9;fill-opacity:0.97894736;stroke:none;stroke-width:0.26458332;stroke-opacity:1" />
    </content-loader>
    <content-loader [width]="300" [height]="50">
        <svg:rect id="rect3686" width="100%" height="40" x="0" y="0" rx="3" ry="3"
            style="fill:#f9f9f9;fill-opacity:0.97894736;stroke:none;stroke-width:0.26458332;stroke-opacity:1" />
    </content-loader>
</div>


// WEBPACK FOOTER //
// ./src/app/element/report-scrollspy/report-scrollspy.component.html